import React from "react";

/**
 * Password strength indicator.
 *
 * Regole:
 * - min 8 caratteri
 * - almeno una lettera
 * - almeno un numero
 * - bonus: maiuscola + speciale
 *
 * Livelli: weak (0-1), medium (2), strong (3-4), verystrong (5)
 */
export function PasswordStrength({ password }) {
  const p = password || "";
  const checks = {
    length: p.length >= 8,
    letter: /[A-Za-z]/.test(p),
    digit: /\d/.test(p),
    upper: /[A-Z]/.test(p),
    special: /[^A-Za-z0-9]/.test(p),
  };
  const score = Object.values(checks).filter(Boolean).length;

  let label = "Debole";
  let color = "bg-red-500";
  let textColor = "text-red-700";
  if (score >= 5) { label = "Ottima"; color = "bg-primary"; textColor = "text-primary"; }
  else if (score >= 4) { label = "Forte"; color = "bg-primary/70"; textColor = "text-primary/80"; }
  else if (score >= 3) { label = "Media"; color = "bg-amber-500"; textColor = "text-amber-700"; }

  const pct = (score / 5) * 100;

  return (
    <div className="mt-2 space-y-1.5" data-testid="password-strength">
      <div className="flex items-center gap-2">
        <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
          <div
            className={`h-full transition-all duration-300 ${color}`}
            style={{ width: `${pct}%` }}
          />
        </div>
        <span className={`text-xs font-semibold ${textColor}`} data-testid="password-strength-label">{label}</span>
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-0.5 text-[11px]">
        <span className={checks.length ? "text-primary" : "text-muted-foreground"}>
          {checks.length ? "✓" : "○"} 8+ caratteri
        </span>
        <span className={checks.letter ? "text-primary" : "text-muted-foreground"}>
          {checks.letter ? "✓" : "○"} lettera
        </span>
        <span className={checks.digit ? "text-primary" : "text-muted-foreground"}>
          {checks.digit ? "✓" : "○"} numero
        </span>
        <span className={checks.upper ? "text-primary" : "text-muted-foreground"}>
          {checks.upper ? "✓" : "○"} maiuscola
        </span>
        <span className={checks.special ? "text-primary" : "text-muted-foreground"}>
          {checks.special ? "✓" : "○"} speciale
        </span>
      </div>
    </div>
  );
}
